import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import { Modal, Button, FieldTextInput } from '../../../components';
import css from './PickupModal.css';
import SignatureBox from './SignatureBox';

const PeselModal = ({ isOpen, onClose, onSubmit, listings, onManageDisableScrolling, handleSignProtocol }) => {
  const [step, setStep] = useState('form'); // 'form' | 'signature'
  const [savedValues, setSavedValues] = useState(null);

  const handleFormSubmit = (values) => {
    const { pesel, ...remarks } = values;
    setSavedValues({ pesel, remarks }); // Zapisz dane tymczasowo
    setStep('signature'); // Przejdź do kroku podpisu
    onSubmit({ pesel, remarks });
  };

  const handleFinalSubmit = () => {
    // onSubmit(savedValues);
    onClose();
    setStep('form'); // Reset na przyszłość
    setSavedValues(null);
  };

  return (
    <Modal
      id="PeselModal"
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setStep('form');
        setSavedValues(null);
      }}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.modalContent}>
        {step === 'form' ? (
          <>
            <h2>Uzupełnij dane klienta</h2>
            <FinalForm
              onSubmit={handleFormSubmit}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className={css.form}>
                  <FieldTextInput
                    name="pesel"
                    id="pesel"
                    type="text"
                    label="Numer PESEL"
                    required
                  />

                  <h3>Uwagi do listingów</h3>
                  {listings.map((listing) => (
                    <div key={listing.id.uuid} className={css.listingItem}>
                      <strong>{listing.attributes.title}</strong>
                      <FieldTextInput
                        name={`remarks-${listing.id.uuid}`}
                        type="textarea"
                        id={`remarks-${listing.id.uuid}`}
                        label="Uwagi"
                      />
                    </div>
                  ))}

                  <div className={css.actions}>
                    <Button type="submit">Dalej</Button>
                    <Button type="button" onClick={onClose}>
                      Anuluj
                    </Button>
                  </div>
                </form>
              )}
            />
          </>
        ) : (
          <>
            <h2>Podpisz protokół</h2>
            <div className={css.signatureBox}>
              {/* Tutaj może być komponent do rysowania podpisu, np. react-signature-canvas */}
              <div className={css.signaturePlaceholder}>
                <SignatureBox
                  handleSignProtocol={handleSignProtocol}
                />
              </div>
            </div>
            <div className={css.actions}>
              <Button onClick={handleFinalSubmit}>Zapisz i zamknij</Button>
              <Button onClick={() => setStep('form')}>Powrót</Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

PeselModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  listings: PropTypes.array.isRequired,
};

export default PeselModal;
